import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, Typography,Tooltip } from "antd";
import SidebarMenu from "../../components/common/SidebarMenu";
import { StarFilled } from "@ant-design/icons";
import ProductSection from "../../components/common/ProductSection";
import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import joyLogo from "../../assests/Images/joyLogo.png"
import "./ProductPage.css"; // <-- import new CSS

export default function ProductPage() {
  const { phoneNumber, id } = useParams();
  const { Text } = Typography;

  const [selectedCategory, setSelectedCategory] = useState("single-pack");
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!phoneNumber && !id) return;
    setLoading(true);
    UIRecommendationAPIService.uiRecommend(phoneNumber, id)
      .then((response) => setProductData(response || {}))
      .catch((err) => console.error("Error fetching product data:", err))
      .finally(() => setLoading(false));
  }, [phoneNumber, id]);


  const filterByCategory = (products, category) => {
    if (!Array.isArray(products)) return [];

    return products.filter((p) => {
      const isMultiPack =
        p.is_large_size === true || (p.items_per_pack !== undefined && p.items_per_pack > 1);

      const isSinglePack = !isMultiPack;

      if (category === "single-pack") return isSinglePack;
      if (category === "multi-pack") return isMultiPack;
      return false;
    });
  };

  const highestRatedToShow = filterByCategory(productData?.top_rated_products, selectedCategory);
  const lowestPricedToShow = filterByCategory(productData?.lowest_priced_products, selectedCategory);
  const bestValueToShow = filterByCategory(productData?.best_value_products, selectedCategory);

  const hasMultiPackProducts = [
    productData?.top_rated_products,
    productData?.lowest_priced_products,
    productData?.best_value_products,
  ].some(
    (list) =>
      Array.isArray(list) &&
      list.some((p) => p.is_large_size === true || (p.items_per_pack && p.items_per_pack > 1))
  );

  const hasSinglePackProducts = [
    productData?.top_rated_products,
    productData?.lowest_priced_products,
    productData?.best_value_products,
  ].some(
    (list) =>
      Array.isArray(list) &&
      list.some(
        (p) =>
          (p.is_large_size === false || p.is_large_size === undefined) &&
          (p.items_per_pack === undefined || p.items_per_pack <= 1)
      )
  );

  useEffect(() => {
    if (!productData) return;
    if (hasSinglePackProducts) {
      setSelectedCategory("single-pack");
    } else if (hasMultiPackProducts) {
      setSelectedCategory("multi-pack");
    } else {
      setSelectedCategory(null);
    }
  }, [productData, hasSinglePackProducts, hasMultiPackProducts]);




  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "4rem" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!productData) {
    return <p style={{ textAlign: "center", marginTop: "4rem" }}>No data available</p>;
  }


  return (

    <div align="top" className="layout">
      {/* Sidebar */}
      <SidebarMenu
        selectedCategory={selectedCategory}
        onCategorySelect={setSelectedCategory}
        hasMultiPackProducts={hasMultiPackProducts}
        hasSinglePackProducts={hasSinglePackProducts}
        products={[...highestRatedToShow, ...lowestPricedToShow, ...bestValueToShow]}
      />

      {/* Main content */}
      <main className="product-section">
      <Tooltip title={productData?.display_keywords || productData?.keywords?.replace(/\s*AND\s*/g, ", ")} placement="bottom">
        <Text strong className="keywordsPick" type="secondary" style={{ color: "black", marginBottom:"-10px" }}>
          Top picks for: {productData?.display_keywords || productData?.keywords?.replace(/\s*AND\s*/g, ", ")}
        </Text>
        </Tooltip>

        <ProductSection
          title="Best value pick for"
          subtitle={
            <span className="section-subtitle">
              Products with <strong>best mix</strong> of rating, review counts and{" "}
              <strong>price/unit</strong>
            </span>
          }
          iconType="thumbsUp"
          backgroundColor="#0ae2cd"
          fontColor="#000000"
          products={bestValueToShow}
        />

        <ProductSection
          title="Top Rated Picks"
          subtitle={
            <span className="section-subtitle">
              Products with highest <strong>combined</strong> rating & review counts{" "}
              <strong>across stores</strong>
            </span>
          }
          iconType="star"
          backgroundColor="#ff9fcf"
          fontColor="#000"
          products={highestRatedToShow}
        />

        <ProductSection
          title="Budget"
          subtitle={
            <span className="section-subtitle">
              4+ <StarFilled style={{ color: "#fadb14", margin: "0 4px" }} /> rated products with
              lowest <strong>price</strong> across stores
            </span>
          }
          iconType="dollar"
          backgroundColor="#005cff"
          fontColor="#fff"
          products={lowestPricedToShow}
        />


      </main>
    </div>
  );
}